import { Icon } from "@iconify/react";
import { Button, Modal } from "../common";

const DirectCallModal = ({
  isOpen,
  onClose,
  businessName = "",
  businessPhoneNumber = "",
  isAvailable = false,
}) => {
  const Header = () => (
    <div className="flex flex-row items-center gap-3">
      <img
        src="/icons/direct_call.svg"
        alt="direct call"
        className="w-12 h-12"
      />
      <div>
        <h3 className="text-xl font-semibold">Call Business</h3>
        <p className="text-sm text-[#253477B2]">{businessName}</p>
      </div>
    </div>
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} header={<Header />}>
      <div className="bg-[linear-gradient(180deg,#F1F5FF_0%,#FFF_100%)] rounded-2xl border border-primary-blur-02 p-[25px] flex flex-col items-center justify-center">
        <p className="text-sm text-[#253477B2]">Phone Number</p>
        <p className="text-2xl font-bold mt-2">{businessPhoneNumber}</p>
        {isAvailable && (
          <div className="px-2.5 py-[3px] rounded-lg bg-primary-blur-02 text-primary mt-4 flex flex-row items-center justify-center gap-2">
            <Icon
              icon="mdi:checkbox-marked-circle-outline"
              className="w-3 h-3"
            />
            <span className="text-xs">Available</span>
          </div>
        )}
      </div>

      <div className="mt-[15px] w-full flex lg:flex-row flex-col items-center gap-3">
        <Button
          variant="secondary-blur"
          label="Cancel"
          className="font-semibold rounded-lg lg:w-1/2 w-full"
        />
        <Button
          variant="primary-gradient"
          label="Call Now"
          icon="mdi:phone-outline"
          className="font-semibold rounded-lg lg:w-1/2 w-full"
        />
      </div>
    </Modal>
  );
};

export default DirectCallModal;
